import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * A token for skipping authentication in an HTTP context.
 */
export const SKIP_AUTHENTICATION = new HttpContextToken<boolean>(() => false);

/**
 * A token for specifying ignored statuses in an HTTP context.
 */
export const IGNORED_STATUSES = new HttpContextToken<string[]>(() => []);

/**
 * A token for skipping the error handler in an HTTP context.
 */
export const SKIP_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);

/**
 * A token for skipping the loader in the ui for an HTTP context
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const ADD_API_HEADERS = new HttpContextToken<boolean>(() => false);

export const addApiHeaders = (context: HttpContext): HttpContext => context.set(ADD_API_HEADERS, true);

/**
 * Sets the SKIP_LOADER flag in the given HTTP context
 *
 * @param context  - The HTTP context to modifiy
 * @returns The modified HTTP context
 */
export const skipLoader = (context: HttpContext): HttpContext => context.set(SKIP_LOADER, true);

/**
 * Sets the skip authentication flag in the given HTTP context.
 *
 * @param context - The HTTP context to modify.
 * @returns The modified HTTP context.
 */
export const skipAuthentication = (context: HttpContext) => {
    return context.set(SKIP_AUTHENTICATION, true);
};

/**
 * Sets the skip error handler flag in the given HTTP context.
 *
 * @param context - The HTTP context to modify.
 * @returns The modified HTTP context.
 */
export const ignoreError = (context: HttpContext): HttpContext => {
    return context.set(SKIP_ERROR_HANDLER, true);
};

/**
 * Sets the ignored error codes in the given HTTP context.
 *
 * @param context - The HTTP context to modify.
 * @param codes - The array of error codes to ignore.
 * @returns The modified HTTP context.
 */
export const ignoreErrorWithCodes = (context: HttpContext, codes: Array<string> = []): HttpContext => {
    return context.set(IGNORED_STATUSES, codes);
};

/**
 * Creates a new HTTP context.
 *
 * @returns A new instance of the HTTP context.
 */
export const getNewContext = (): HttpContext => {
    return new HttpContext();
};
